export const getStartDate = state => state.planning.startDate;
export const getEndDate = state => state.planning.endDate;
export const getBooksStatistics = state => state.planning.books;
export const getStats = state => state.planning.stats;
export const getPlanBooks = state => state.planning.filter;
export const getTrainingBooks = state => state.planning.books;
